import * as requests from '@/common/requests';

export default function install(Vue) {  // install(Vue, options = {}) {
    Vue.prototype.$requests = requests;
}

